export default {"src":"/_next/static/media/facebook.e9dbd352.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};